import { render, staticRenderFns } from "./CanceledArticles.vue?vue&type=template&id=02c441f5&scoped=true&"
import script from "./CanceledArticles.vue?vue&type=script&lang=js&"
export * from "./CanceledArticles.vue?vue&type=script&lang=js&"
import style0 from "./CanceledArticles.vue?vue&type=style&index=0&id=02c441f5&prod&lang=css&"
import style1 from "./CanceledArticles.vue?vue&type=style&index=1&id=02c441f5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02c441f5",
  null
  
)

export default component.exports